import { App } from "@capacitor/app";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { APP_V2_USER_EVENTS } from "../../lib/analytics/events";
import { logEvent } from "../../lib/analytics/log";
import { invalidateShifts } from "../invalidateShifts";

export function useInvalidateShiftsOnDeeplink() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const urlOpenListener = App.addListener("appUrlOpen", () => {
      logEvent(APP_V2_USER_EVENTS.SHIFTS_INVALIDATED_ON_DEEPLINK);

      void invalidateShifts(queryClient);
    });

    const resumeListener = App.addListener("resume", () => {
      logEvent(APP_V2_USER_EVENTS.SHIFTS_INVALIDATED_ON_APP_RESUMED);

      void invalidateShifts(queryClient);
    });

    return () => {
      void urlOpenListener?.then(async (listener) => {
        await listener?.remove();
      });

      void resumeListener?.then(async (listener) => {
        await listener?.remove();
      });
    };
  }, [queryClient]);
}
